import { useDisclosure } from "@mantine/hooks"
import { isInRange, useForm } from "@mantine/form"
import { httpsCallable } from "firebase/functions"

import { useCloudFunction } from "../../../../hooks/useCloudFunction"
import { firebase } from "../../../../services/firebase/firebase"
import { DeviceDocument } from "../../../../contexts/devices-context"
import { useLanguage } from "../../../../contexts/language-context"
import { DevicesUpdateData } from "../../../../functions/devices/devices-update"

export default (device: DeviceDocument) => {
    const [edit, { open, close }] = useDisclosure(false)
    const { L } = useLanguage()
    const { onStart, onSuccess, onError, processing } = useCloudFunction("device-update")
    const form = useForm({
        initialValues: {
            latitude: device.coordinates?.latitude,
            longitude: device.coordinates?.longitude,
        },
        validate: {
            latitude: isInRange({ min: -90, max: 90 }, L("Must be between %s and %s", -90, 90)),
            longitude: isInRange({ min: -180, max: 180 }, L("Must be between %s and %s", -180, 180)),
        },
        validateInputOnChange: true,
    })

    const onSubmit = (values: typeof form.values) => {
        onStart(L("Updating device details..."))
        httpsCallable<DevicesUpdateData>(
            firebase.functions,
            "devices-update",
        )({
            id: device.id,
            group: device.group,
            organisation: device.organisation,
            coordinates:
                values.latitude && values.longitude
                    ? { latitude: values.latitude, longitude: values.longitude }
                    : undefined,
        })
            .then(onSuccess())
            .then(close)
            .catch(onError())
    }

    return {
        form,
        onSubmit,
        edit,
        open,
        setCoordinates(latitude: number, longitude: number) {
            form.setValues({ latitude, longitude })
        },
        cancel() {
            close()
            form.reset()
        },
        reset: form.reset,
        processing,
    }
}
